module.exports = __webpack_public_path__ + "img/logoBpB@2x.a6b1c019.png";